import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ allowedRoles }) => {
    const { user, loading, setShowAuthPopup } = useAuth();

    if (loading) {
        // You might want to render a loading spinner here
        return <div className="flex justify-center items-center h-screen">Loading...</div>;
    }

    if (!user) {
        // Trigger auth popup
        setShowAuthPopup(true);
        // Redirect to home if not logged in
        return <Navigate to="/" replace />;
    }

    if (allowedRoles && !allowedRoles.includes(user.role)) {
        // Redirect to appropriate page based on role if they don't have permission
        if (user.role === 'admin') {
            return <Navigate to="/admin" replace />;
        } else {
            return <Navigate to="/" replace />;
        }
    }

    return <Outlet />;
};

export default ProtectedRoute;
